import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  private formErrors: any = Object;
  private form!: FormGroup;
  private formSubmitted: Boolean = false;
  private onSubmitValid = false;

  constructor(
  ) { }

  setForm(formGroup: FormGroup) {
    this.onSubmitValid = false;
    this.formSubmitted = false;
    this.form = formGroup;
  }

  setValue(value: any) {
    this.form.setValue(value);
  }

  getForm() {
    return this.form;
  }

  setErrors(errors: Object) {
    this.formErrors = errors;
  }

  isSubmitted(submitted: boolean) {
    this.formSubmitted = submitted;
  }

  onSubmitValidate(validate: boolean) {
    this.onSubmitValid = validate;
  }

  getError(formControl: any, errorCode?: any, path?: string[]): any {
    if (this.form === undefined) {
      return '';
    }
    if (this.onSubmitValid === true && this.formSubmitted !== true) {
      return '';
    }
    if (
      formControl !== undefined &&
      this.form.controls[formControl] === undefined
    ) {
      return '';
    }
    if (errorCode === undefined && this.form.controls[formControl].errors) {
      const errors: any = this.form.controls[formControl].errors;
      errorCode = Object.keys(errors)[0];
    }
    if (
      this.form.controls[formControl].invalid &&
      this.form.controls[formControl].hasError(errorCode, path)
    ) {
      if (
        this.formErrors[formControl] !== undefined &&
        this.formErrors[formControl][errorCode] !== undefined
      ) {
        return this.formErrors[formControl][errorCode];
      } else if (
        this.formErrors.errors !== undefined &&
        this.formErrors.errors[errorCode] !== undefined
      ) {
        return this.formErrors.errors[errorCode];
      } else {
        return '';
      }
    }
  }

  hasError(formControl?: string, errorCode?: string, path?: string[]): boolean {
    if (this.form === undefined) {
      return false;
    }
    if (this.onSubmitValid === true && this.formSubmitted !== true) {
      return false;
    }
    if (
      formControl !== undefined &&
      this.form.controls[formControl] === undefined
    ) {
      return this.form.invalid;
    }
    if (
      formControl !== undefined &&
      errorCode !== undefined &&
      errorCode !== ''
    ) {
      return (
        this.form.controls[formControl].invalid &&
        this.form.controls[formControl].hasError(errorCode, path)
      );
    } else if (formControl !== undefined && formControl !== '') {
      return (
        (this.formSubmitted ||
          this.form.controls[formControl].dirty ||
          this.form.controls[formControl].touched) &&
        this.form.controls[formControl].invalid
      );
    } else {
      return this.form.invalid;
    }
  }

  getValue(formControl?: string): any {
    if (this.form === undefined) {
      return formControl !== undefined ? undefined : {};
    }
    if (formControl !== undefined) {
      return this.form.value[formControl] !== undefined
        ? this.form.value[formControl]
        : '';
    } else {
      return this.form.value;
    }
  }

  hasFocus(): any {
    const fields = Object.keys(this.form.controls);
    for (let index = 0; index < fields.length; index++) {
      const field = fields[index];
      const control = this.form.controls[field];
      if (control.invalid) {
        const elm: any = document.querySelector('[formcontrolname="' + field + '"]');
        if (elm) elm?.focus();
        break;
      }
    }
  }

  reset(): boolean {
    if (this.form === undefined) {
      return false;
    }
    this.form.reset();
    this.form.markAsPristine();
    this.form.markAsUntouched();
    this.form.updateValueAndValidity();
    return true;
  }
}
